import { render, staticRenderFns } from "./QuoteDetail.vue?vue&type=template&id=59cb8dc0&"
import script from "./QuoteDetail.vue?vue&type=script&lang=ts&"
export * from "./QuoteDetail.vue?vue&type=script&lang=ts&"
import style0 from "./QuoteDetail.vue?vue&type=style&index=0&id=59cb8dc0&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports